import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { ProductCategoryPage } from '@/features/products'

export const Route = createFileRoute('/_authenticated/products/categories')({
  component: () => (
    <RequirePermission permission='product_categories.read'>
      <ProductCategoryPage />
    </RequirePermission>
  ),
})
